import type { Namespace } from "@/i18n/types";
import nsGridEN from "./en";
import nsGridJA from "./ja";

export const nsGrid = {
  name: "grid",
  locales: {
    ja: nsGridJA,
    en: nsGridEN,
  },
} satisfies Namespace<"grid", typeof nsGridJA>;
